export const getDateValueOrPlaceholder = ({ isType, placeholder, format, inputValue }) =>
  inputValue && isType ? format(inputValue) : placeholder;
